import { render } from "./TopQuestionView.vue?vue&type=template&id=0d5446a2"
import script from "./TopQuestionView.vue?vue&type=script&lang=js"
export * from "./TopQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__